import Axios from 'axios'


export default {
    brand: "CHU",
    project: "landlords",
    projectTitle: "Landlords",
    documentTitle: "Get a Quote | Landlords",
    paymentSuccessRedirect: "http://www.chu.com.au/",
    icon: require("./images/favicon.ico"),
    environment: process.env.REACT_APP_ENVIRONMENT,
    /*
     * Switch the flag below off if maintenance page should not be presented anymore
     */
    showMaintenance: true,

    // Axios
    axios: Axios.create(),


    // Endpoints
    endpoints:{
        step1:              `${process.env.REACT_APP_ENDPOINT_HOST}/${process.env.REACT_APP_CHULANDLORDS_PATH}/quote/v1`,
        step2:              `${process.env.REACT_APP_ENDPOINT_HOST}/${process.env.REACT_APP_CHULANDLORDS_PATH}/property/v1`,
        step3:              `${process.env.REACT_APP_ENDPOINT_HOST}/${process.env.REACT_APP_CHULANDLORDS_PATH}/coverage/v1`,
        step5:              `${process.env.REACT_APP_ENDPOINT_HOST}/${process.env.REACT_APP_CHULANDLORDS_PATH}/finalise/v1`,

        template:           `${process.env.REACT_APP_ENDPOINT_HOST}/${process.env.REACT_APP_CHULANDLORDS_PATH}/details/v1`,
        
        email:              `${process.env.REACT_APP_ENDPOINT_HOST}/${process.env.REACT_APP_CHULANDLORDS_PATH}/documents/v1`,
        payOffline:         `${process.env.REACT_APP_ENDPOINT_HOST}/${process.env.REACT_APP_CHULANDLORDS_PATH}/documents/v1`,
        paymentAuthorise:   `${process.env.REACT_APP_ENDPOINT_HOST}/${process.env.REACT_APP_CHULANDLORDS_PATH}/authorise/v1`,
        paymentInitiate:    `${process.env.REACT_APP_ENDPOINT_HOST}/${process.env.REACT_APP_CHULANDLORDS_PATH}/initiate/v1`,
        payInstalments:     `${process.env.REACT_APP_INSTALMENTS_PATH}`,
        payInstalmentsMPF:  `${process.env.REACT_APP_INSTALMENTS_PATH_MPF}`,

        findToken:          `${process.env.REACT_APP_ENDPOINT_HOST}/${process.env.REACT_APP_CHULANDLORDS_PATH}/findtoken/v1`,
        restore:            `${process.env.REACT_APP_ENDPOINT_HOST}/${process.env.REACT_APP_CHULANDLORDS_PATH}/details/v1`,
        suburbAutoComplete: `${process.env.REACT_APP_ENDPOINT_HOST}/${process.env.REACT_APP_POSTCODE_PATH}`,
        postcodeAutoComplete:`${process.env.REACT_APP_ENDPOINT_HOST}/${process.env.REACT_APP_SMART_ADDRESS_PATH}`,
        saveAndExit: {
            "/step-4":      `${process.env.REACT_APP_ENDPOINT_HOST}/${process.env.REACT_APP_CHULANDLORDS_PATH}/overviewSaveAndExit/v1`,
        },

        addressValidation:  `${process.env.REACT_APP_ENDPOINT_HOST}/${process.env.REACT_APP_CHULANDLORDS_PATH}/validateaddress/v1`,
        options:            `${process.env.REACT_APP_ENDPOINT_HOST}/${process.env.REACT_APP_CHULANDLORDS_PATH}/options/v1`,
        excesses:           `${process.env.REACT_APP_ENDPOINT_HOST}/${process.env.REACT_APP_CHULANDLORDS_PATH}/excesses/v1`,
        limits:             `${process.env.REACT_APP_ENDPOINT_HOST}/${process.env.REACT_APP_CHULANDLORDS_PATH}/limits/v1`,
        sumsinsured:        `${process.env.REACT_APP_ENDPOINT_HOST}/${process.env.REACT_APP_CHULANDLORDS_PATH}/sumsinsured/v1`,
        paymentOptions:     `${process.env.REACT_APP_ENDPOINT_HOST}/${process.env.REACT_APP_CHULANDLORDS_PATH}/paymentOptions/v1`,
        validateAddress:    `${process.env.REACT_APP_ENDPOINT_HOST}/${process.env.REACT_APP_CHULANDLORDS_PATH}/validateaddress/v1`,
    },


    // RESTORE
    restore:{
        transformer: fields => ({
            ...fields,
            coverageType: fields.coverType // For some reason the coverageType field comes back as coverType from the restore endpoint, so we transform it to soverageType
        }),
        fieldNames:{
            quoteNumber:"quoteNumber",
            email:"email"
        }
    },


    // PROGRESS
    progressGroups: [{
        "/step-1": "Step 1",
        "/step-2": "Step 2",
        "/step-3": "Step 3",
        "/step-4": "Premium Summary"
    }],

    
}




// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/landlords/config.ts